export const MODULAR_IDENTIFIED_GENERIC_ACTIVITY_LIST_COLUMN_VISIBILITY_AND_SORT_ORDER =
	'MODULAR_IDENTIFIED_GENERIC_ACTIVITY_LIST_COLUMN_VISIBILITY_AND_SORT_ORDER';
